<template>
  <div>
    <!--Charts-->
    <div class="row">
      <div class="col-sm-6 col-md-4 col-12">
        <cost-predict-card title="SO FAR COST">
        </cost-predict-card>
      </div>

      <div class="col-sm-6  col-md-4 col-12">
        <change-cost-card title="CHANGE IN COST">
        </change-cost-card>
      </div>
      <div class="col-sm-6  col-md-4 col-12">
        <usage-estimate-card title="USAGE ESTIMATE">
        </usage-estimate-card>
      </div>

      <div class="col-sm-6 col-md-4 col-12">
        <appliance-card title="ACTIVE APPLIANCE">
        </appliance-card>
      </div>

      <div class="col-sm-6 col-md-4 col-12">
				<daily-power-map-card title="DAILY POWER MAP">
				</daily-power-map-card>
      </div>

      <div class="col-sm-6 col-md-4 col-12">
				<carbon-footprint-card :title="getTitle()">
				</carbon-footprint-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
  CostPredictCard,
  ChangeCostCard,
  UsageEstimateCard,
  ApplianceCard,
	DailyPowerMapCard,
	CarbonFootprintCard
} from "@/components/index";

export default {
  components: {
    CostPredictCard,
    ChangeCostCard,
    UsageEstimateCard,
    ApplianceCard,
		DailyPowerMapCard,
		CarbonFootprintCard
  },
  computed: {
		...mapGetters({
			user: 'auth/getUser'
		})
	}, 
  data() {
    return {
      hasGenCircuit: false
    };
  },
  mounted() {
    this.user.devices.forEach(item => {
      if (item.device_type == 'Electricity Gen (Wh)') this.hasGenCircuit = true;
    });
  },
  methods: {
    getTitle() {
      if (this.hasGenCircuit) {
        return 'SOLAR GENERATED';
      }
      return 'CARBON FOOTPRINT';
    }
  }
};
</script>
<style>
</style>
